import { render, staticRenderFns } from "./valmistumispyynnot-list.vue?vue&type=template&id=28082250&scoped=true&"
import script from "./valmistumispyynnot-list.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-list.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnot-list.vue?vue&type=style&index=0&id=28082250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28082250",
  null
  
)

export default component.exports